import * as ambassadorWixRestaurantsV1FulfillmentMethod from './restaurants-v1-fulfillment-method-fulfillment-methods.http.js';
import * as ambassadorWixRestaurantsV1FulfillmentMethodTypes from './restaurants-v1-fulfillment-method-fulfillment-methods.types.js';
import * as ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes from './restaurants-v1-fulfillment-method-fulfillment-methods.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createFulfillmentMethod(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.CreateFulfillmentMethodRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.CreateFulfillmentMethodRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.CreateFulfillmentMethodResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.CreateFulfillmentMethodResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.createFulfillmentMethod(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/fulfillment-methods',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateFulfillmentMethods(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.BulkCreateFulfillmentMethodsRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.BulkCreateFulfillmentMethodsRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.BulkCreateFulfillmentMethodsResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.BulkCreateFulfillmentMethodsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.bulkCreateFulfillmentMethods(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/fulfillment-methods/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getFulfillmentMethod(): __PublicMethodMetaInfo<
  'GET',
  { fulfillmentMethodId: string },
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.GetFulfillmentMethodRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.GetFulfillmentMethodRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.GetFulfillmentMethodResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.GetFulfillmentMethodResponse
> {
  const payload = { fulfillmentMethodId: ':fulfillmentMethodId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.getFulfillmentMethod(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/fulfillment-methods/{fulfillmentMethodId}',
    pathParams: { fulfillmentMethodId: 'fulfillmentMethodId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateFulfillmentMethod(): __PublicMethodMetaInfo<
  'PATCH',
  { fulfillmentMethodId: string },
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.UpdateFulfillmentMethodRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.UpdateFulfillmentMethodRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.UpdateFulfillmentMethodResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.UpdateFulfillmentMethodResponse
> {
  const payload = { fulfillmentMethod: { id: ':fulfillmentMethodId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.updateFulfillmentMethod(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/fulfillment-methods/{fulfillmentMethod.id}',
    pathParams: { fulfillmentMethodId: 'fulfillmentMethodId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteFulfillmentMethod(): __PublicMethodMetaInfo<
  'DELETE',
  { fulfillmentMethodId: string },
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.DeleteFulfillmentMethodRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.DeleteFulfillmentMethodRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.DeleteFulfillmentMethodResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.DeleteFulfillmentMethodResponse
> {
  const payload = { fulfillmentMethodId: ':fulfillmentMethodId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.deleteFulfillmentMethod(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/fulfillment-methods/{fulfillmentMethodId}',
    pathParams: { fulfillmentMethodId: 'fulfillmentMethodId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryFulfillmentMethods(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.QueryFulfillmentMethodsRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.QueryFulfillmentMethodsRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.QueryFulfillmentMethodsResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.QueryFulfillmentMethodsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.queryFulfillmentMethods(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/fulfillment-methods/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listFulfillmentMethods(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.ListFulfillmentMethodsRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.ListFulfillmentMethodsRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.ListFulfillmentMethodsResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.ListFulfillmentMethodsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.listFulfillmentMethods(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/fulfillment-methods',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAvailableFulfillmentMethodsForAddress(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.ListAvailableFulfillmentMethodsForAddressRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.ListAvailableFulfillmentMethodsForAddressRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.ListAvailableFulfillmentMethodsForAddressResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.ListAvailableFulfillmentMethodsForAddressResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.listAvailableFulfillmentMethodsForAddress(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/fulfillment-methods/available-for-address',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAccumulatedFulfillmentMethodsAvailability(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.GetAccumulatedFulfillmentMethodsAvailabilityRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.GetAccumulatedFulfillmentMethodsAvailabilityRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.GetAccumulatedFulfillmentMethodsAvailabilityResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.GetAccumulatedFulfillmentMethodsAvailabilityResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.getAccumulatedFulfillmentMethodsAvailability(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/fulfillment-methods/accumulated-availability',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCombinedMethodAvailability(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.GetCombinedMethodAvailabilityRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.GetCombinedMethodAvailabilityRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.GetCombinedMethodAvailabilityResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.GetCombinedMethodAvailabilityResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.getCombinedMethodAvailability(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/fulfillment-methods/combined-availability',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAggregatedMethodAvailability(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.GetAggregatedMethodAvailabilityRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.GetAggregatedMethodAvailabilityRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.GetAggregatedMethodAvailabilityResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.GetAggregatedMethodAvailabilityResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.getAggregatedMethodAvailability(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/fulfillment-methods/aggregated-availability',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateFulfillmentMethodTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.BulkUpdateFulfillmentMethodTagsRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.BulkUpdateFulfillmentMethodTagsRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.BulkUpdateFulfillmentMethodTagsResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.BulkUpdateFulfillmentMethodTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.bulkUpdateFulfillmentMethodTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/fulfillment-methods/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateFulfillmentMethodTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.BulkUpdateFulfillmentMethodTagsByFilterRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.BulkUpdateFulfillmentMethodTagsByFilterRequest,
  ambassadorWixRestaurantsV1FulfillmentMethodUniversalTypes.BulkUpdateFulfillmentMethodTagsByFilterResponse,
  ambassadorWixRestaurantsV1FulfillmentMethodTypes.BulkUpdateFulfillmentMethodTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsV1FulfillmentMethod.bulkUpdateFulfillmentMethodTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/fulfillment-methods/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  FulfillmentMethod as FulfillmentMethodOriginal,
  FulfillmentMethodMethodOptionsOneOf as FulfillmentMethodMethodOptionsOneOfOriginal,
  FulfillmentMethodType as FulfillmentMethodTypeOriginal,
  FulfillmentMethodTypeWithLiterals as FulfillmentMethodTypeWithLiteralsOriginal,
  PickupInfo as PickupInfoOriginal,
  CommonAddress as CommonAddressOriginal,
  CommonAddressStreetOneOf as CommonAddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  DeliveryInfo as DeliveryInfoOriginal,
  DeliveryArea as DeliveryAreaOriginal,
  DeliveryAreaAreaOptionsOneOf as DeliveryAreaAreaOptionsOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Radius as RadiusOriginal,
  Unit as UnitOriginal,
  UnitWithLiterals as UnitWithLiteralsOriginal,
  PostalCode as PostalCodeOriginal,
  CustomArea as CustomAreaOriginal,
  Availability as AvailabilityOriginal,
  DayOfWeekAvailability as DayOfWeekAvailabilityOriginal,
  EntitiesDayOfWeek as EntitiesDayOfWeekOriginal,
  EntitiesDayOfWeekWithLiterals as EntitiesDayOfWeekWithLiteralsOriginal,
  TimeOfDayRange as TimeOfDayRangeOriginal,
  TimeOfDay as TimeOfDayOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  DineInInfo as DineInInfoOriginal,
  DineInInfoAdditionalInfoLabelOptionsOneOf as DineInInfoAdditionalInfoLabelOptionsOneOfOriginal,
  AdditionalInfoLabel as AdditionalInfoLabelOriginal,
  AdditionalInfoLabelWithLiterals as AdditionalInfoLabelWithLiteralsOriginal,
  CustomConfig as CustomConfigOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateFulfillmentMethodRequest as CreateFulfillmentMethodRequestOriginal,
  CreateFulfillmentMethodResponse as CreateFulfillmentMethodResponseOriginal,
  BulkCreateFulfillmentMethodsRequest as BulkCreateFulfillmentMethodsRequestOriginal,
  BulkCreateFulfillmentMethodsResponse as BulkCreateFulfillmentMethodsResponseOriginal,
  BulkCreateFulfillmentMethodResult as BulkCreateFulfillmentMethodResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  GetFulfillmentMethodRequest as GetFulfillmentMethodRequestOriginal,
  GetFulfillmentMethodResponse as GetFulfillmentMethodResponseOriginal,
  UpdateFulfillmentMethodRequest as UpdateFulfillmentMethodRequestOriginal,
  UpdateFulfillmentMethodResponse as UpdateFulfillmentMethodResponseOriginal,
  DeleteFulfillmentMethodRequest as DeleteFulfillmentMethodRequestOriginal,
  DeleteFulfillmentMethodResponse as DeleteFulfillmentMethodResponseOriginal,
  QueryFulfillmentMethodsRequest as QueryFulfillmentMethodsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryFulfillmentMethodsResponse as QueryFulfillmentMethodsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  ListFulfillmentMethodsRequest as ListFulfillmentMethodsRequestOriginal,
  ListFulfillmentMethodsResponse as ListFulfillmentMethodsResponseOriginal,
  ListAvailableFulfillmentMethodsForAddressRequest as ListAvailableFulfillmentMethodsForAddressRequestOriginal,
  ListAvailableFulfillmentMethodsForAddressResponse as ListAvailableFulfillmentMethodsForAddressResponseOriginal,
  ListActiveFulfillmentMethodsRequest as ListActiveFulfillmentMethodsRequestOriginal,
  ListActiveFulfillmentMethodsResponse as ListActiveFulfillmentMethodsResponseOriginal,
  GetAccumulatedFulfillmentMethodsAvailabilityRequest as GetAccumulatedFulfillmentMethodsAvailabilityRequestOriginal,
  GetAccumulatedFulfillmentMethodsAvailabilityResponse as GetAccumulatedFulfillmentMethodsAvailabilityResponseOriginal,
  GetCombinedMethodAvailabilityRequest as GetCombinedMethodAvailabilityRequestOriginal,
  GetCombinedMethodAvailabilityResponse as GetCombinedMethodAvailabilityResponseOriginal,
  GetAggregatedMethodAvailabilityRequest as GetAggregatedMethodAvailabilityRequestOriginal,
  GetAggregatedMethodAvailabilityResponse as GetAggregatedMethodAvailabilityResponseOriginal,
  BulkUpdateFulfillmentMethodTagsRequest as BulkUpdateFulfillmentMethodTagsRequestOriginal,
  BulkUpdateFulfillmentMethodTagsResponse as BulkUpdateFulfillmentMethodTagsResponseOriginal,
  CommonItemMetadata as CommonItemMetadataOriginal,
  BulkUpdateFulfillmentMethodTagsResult as BulkUpdateFulfillmentMethodTagsResultOriginal,
  CommonBulkActionMetadata as CommonBulkActionMetadataOriginal,
  BulkUpdateFulfillmentMethodTagsByFilterRequest as BulkUpdateFulfillmentMethodTagsByFilterRequestOriginal,
  BulkUpdateFulfillmentMethodTagsByFilterResponse as BulkUpdateFulfillmentMethodTagsByFilterResponseOriginal,
  SitePropertiesNotification as SitePropertiesNotificationOriginal,
  SitePropertiesEvent as SitePropertiesEventOriginal,
  Properties as PropertiesOriginal,
  Categories as CategoriesOriginal,
  Locale as LocaleOriginal,
  Address as AddressOriginal,
  AddressHint as AddressHintOriginal,
  PlacementType as PlacementTypeOriginal,
  PlacementTypeWithLiterals as PlacementTypeWithLiteralsOriginal,
  GeoCoordinates as GeoCoordinatesOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  ConsentPolicy as ConsentPolicyOriginal,
  Translation as TranslationOriginal,
  ChangeContext as ChangeContextOriginal,
  ChangeContextPayloadOneOf as ChangeContextPayloadOneOfOriginal,
  PropertiesChange as PropertiesChangeOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCloned as SiteClonedOriginal,
  Empty as EmptyOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdateFulfillmentMethodTagsApplicationErrors as BulkUpdateFulfillmentMethodTagsApplicationErrorsOriginal,
  BulkUpdateFulfillmentMethodTagsByFilterApplicationErrors as BulkUpdateFulfillmentMethodTagsByFilterApplicationErrorsOriginal,
} from './restaurants-v1-fulfillment-method-fulfillment-methods.types.js';
